export function formatTelefon(ham: string): string {
  if (!ham) return '';
  let rakamlar = ham.replace(/[^0-9]/g, '');
  if (rakamlar.length === 0) return '';
  if (rakamlar[0] !== '0') rakamlar = '0' + rakamlar;
  rakamlar = rakamlar.slice(0, 11);
  const r = rakamlar;
  if (r.length <= 1) return r;
  if (r.length <= 4) return r[0] + ' ' + r.slice(1);
  if (r.length <= 7) return r[0] + ' ' + r.slice(1, 4) + ' ' + r.slice(4);
  if (r.length <= 9) return r[0] + ' ' + r.slice(1, 4) + ' ' + r.slice(4, 7) + ' ' + r.slice(7);
  return r[0] + ' ' + r.slice(1, 4) + ' ' + r.slice(4, 7) + ' ' + r.slice(7, 9) + ' ' + r.slice(9, 11);
}